var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_4",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13734",
    "data-name": "Group 13734",
    transform: "translate(-140 -527)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 140, 527)",
    filter: "url(#Ellipse_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-2",
    "data-name": "Ellipse 4",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(9 13)",
    fill: "#b61424"
  })), /*#__PURE__*/React.createElement("path", {
    id: "badge_FILL0_wght400_GRAD0_opsz48",
    d: "M81.933-854.224a1.855,1.855,0,0,1-1.353-.58,1.855,1.855,0,0,1-.58-1.353v-15.466a1.855,1.855,0,0,1,.58-1.353,1.855,1.855,0,0,1,1.353-.58h8.055v-4.511a1.855,1.855,0,0,1,.58-1.353,1.869,1.869,0,0,1,1.367-.58h1.907a1.869,1.869,0,0,1,1.367.58,1.855,1.855,0,0,1,.58,1.353v4.511h8.055a1.855,1.855,0,0,1,1.353.58,1.855,1.855,0,0,1,.58,1.353v15.466a1.855,1.855,0,0,1-.58,1.353,1.855,1.855,0,0,1-1.353.58Zm0-1.933h21.91v-15.466H95.788v.967a1.8,1.8,0,0,1-.58,1.418,1.99,1.99,0,0,1-1.367.516H91.935a1.99,1.99,0,0,1-1.367-.516,1.8,1.8,0,0,1-.58-1.418v-.967H81.933ZM84.9-859.6h7.7v-.451a1.865,1.865,0,0,0-.29-1.031,1.456,1.456,0,0,0-.741-.612,12.942,12.942,0,0,0-1.611-.467,5.9,5.9,0,0,0-1.128-.113,6.382,6.382,0,0,0-1.3.145,14.238,14.238,0,0,0-1.563.435,1.443,1.443,0,0,0-.773.612,1.865,1.865,0,0,0-.29,1.031Zm10.826-2.159H101.2v-1.611H95.724Zm-6.9-1.611a1.678,1.678,0,0,0,1.232-.507,1.678,1.678,0,0,0,.507-1.232,1.678,1.678,0,0,0-.507-1.232,1.678,1.678,0,0,0-1.232-.507,1.678,1.678,0,0,0-1.232.507,1.678,1.678,0,0,0-.507,1.232,1.678,1.678,0,0,0,.507,1.232A1.678,1.678,0,0,0,88.828-863.374Zm6.9-2.03H101.2v-1.611H95.724Zm-3.8-5.252h1.933v-7.411H91.922ZM92.888-863.89Z",
    transform: "translate(83.112 1432.224)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fa563f3a14371e6a3b1c47727b3c8fe5.svg";
export { ForwardRef as ReactComponent };